'use client'
import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import config from "../../config";
import { empresasIntegras_item } from '../../json/empresasIntegrasItem';
import './empresasintegras.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const EmpresasIntegras = () => {  
  const [pdf,setPdf]=useState(null)
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  return (
    <div className='container transparencia-container container-mh'>
        <div className='row'>
          <div className='col-12'>
            <h1 className='title'>Empresas Íntegras</h1>
            <hr className='hr-gob'/>
          </div>
          {
                 empresasIntegras_item.map((item, index)=>(
                  <div key={ index } onClick={()=>{
                   let url=item.url ? item.url : "DetalleRubro/" + item.nombre 
                   url=config.baseUrl+url;
                   setPdf(url)
                  }} className='col-md-4 col-sm-6 col-12 rubro_enlace'>
                    <div className='rubro_container'>
                      <div className='rubro_icono'>
                        <img src={"http://cdn.hidalgo.gob.mx/plantilla_secretarial/Rubros/PNG/" + item.icono }/>
                      </div>
                      <h3>{ item.nombre }</h3>
                    </div>
                  </div>
                ))
            }
            {/* <Link className='rubros_historicos' to="RubrosHistoricos">Información Ejercicios Anteriores Art. 69 (48 Fracciones)</Link> */}
        </div>
       {pdf && <Document 
       onLoadSuccess={onDocumentLoadSuccess}
       className="pdf-center" file={pdf}>

       {Array.apply(null, Array(numPages))
        .map((x, i)=>i+1)
        .map(page => <Page key={page} className="pdf-page" pageNumber={page}/>)}
                  

        </Document>}
    </div>
  )
}

export default EmpresasIntegras